import { render, staticRenderFns } from "./InvestorApplication.vue?vue&type=template&id=7674ab4f"
import script from "./InvestorApplication.vue?vue&type=script&lang=js"
export * from "./InvestorApplication.vue?vue&type=script&lang=js"
import style0 from "./InvestorApplication.vue?vue&type=style&index=0&id=7674ab4f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports